import styled from "@emotion/styled";
import {ControlGroup} from "@blueprintjs/core";
import {ItemRenderer} from "@blueprintjs/select";
import IndicatorSelect, {IndicatorListItem} from "../../../common/IndicatorSelect";
import {useContext} from "react";
import {ColorizedIndicatorContext, ColorizedIndicatorDispatchContext} from "./ColorizedIndicatorStateProvider";
import {ManifestStatusType} from "./types/manifestAttributes";

const Container = styled.div``;

export const StyledControlGroup = styled(ControlGroup)`
  gap: 8px;
`;

export const manifestStatusOptions: Map<ManifestStatusType, string> = new Map([
  [ManifestStatusType.Future, "Future"],
  [ManifestStatusType.Active, "Active"],
  [ManifestStatusType.Inactive, "Inactive"]
]);

const ManifestAttributeSelector = () => {
  const colorizedIndicatorState = useContext(ColorizedIndicatorContext);
  const colorizedIndicatorDispatch = useContext(ColorizedIndicatorDispatchContext);

  const selectedValues = colorizedIndicatorState.selectedLogic?.manifestAttributes?.manifestStatus;

  const renderManifestStatusType: ItemRenderer<[ManifestStatusType, string]> = (item, {handleClick}) => {
    return (
      <IndicatorListItem key={item[0]} onClick={handleClick} isSelected={item[0] === selectedValues}>
        {item[1]}
      </IndicatorListItem>
    );
  };

  const onSelectManifestStatusType = (item: [ManifestStatusType, string]) => {
    colorizedIndicatorDispatch({type: "SET_MANIFEST_ATTRIBUTES_STATUS", payload: item[0]});
    colorizedIndicatorDispatch({type: "SET_ENGINE_RULES"});
  };

  const onClearManifestStatusType = () => {
    colorizedIndicatorDispatch({type: "SET_MANIFEST_ATTRIBUTES_STATUS", payload: undefined});
    colorizedIndicatorDispatch({type: "SET_ENGINE_RULES"});
  };

  return (
    <Container>
      <IndicatorSelect
        name="manifest-status"
        items={Array.from(manifestStatusOptions)}
        itemRenderer={renderManifestStatusType}
        onSelectedItem={onSelectManifestStatusType}
        placeholderText="Manifest Status"
        selectedItemText={manifestStatusOptions.get(selectedValues as ManifestStatusType)}
        onClear={onClearManifestStatusType}
      />
    </Container>
  );
};

export default ManifestAttributeSelector;
